// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1JRpj","header":"PatientQuestionnaire_header__Hhtnq","info":"PatientQuestionnaire_info__eSyq1"};